<template>
  <div id="new_student_login" v-loading="loading">
    <!-- 学生端登录页 -->
    <div class="title">
      <!-- <div class="t1">欢迎登录</div>
      <div class="t2">考试管理系统——学员端</div> -->
    </div>
    <div class="content">
      <div class="left"></div>
      <div class="slipe"></div>
      <div class="login">
        <div class="top">
          <img src="@/assets/img/logo1.png" alt="" object-fit="scale-down" />
          <!-- <span class="tt">Please Sign In</span> -->
          <!-- <span>请输入用户名及密码</span> -->
        </div>
        <div class="line">
          <el-input
            v-model="userName"
            placeholder="请输入用户名"
            clearable
          ></el-input>
        </div>
        <div class="line">
          <el-input
            v-model="password"
            placeholder="请输入密码"
            clearable
            show-password
            @keyup.enter.native="login"
          ></el-input>
        </div>
        <div class="line">
          <el-input
            v-model="yzm"
            placeholder="请输入验证码"
            clearable
            @keyup.enter.native="login"
          ></el-input>
          <div class="yzm" @click="refreshCode">
            <SIdentify
              :identifyCode="identifyCode"
              :contentWidth="contentWidth"
              :contentHeight="50"
            ></SIdentify>
          </div>
        </div>
        <div class="line">
          <div class="wjmm" @click="forgetPassword">忘记密码</div>
          <div class="perch-active"></div>
          <div class="wjmm" @click="checkAdmin">管理员登录</div>
        </div>
        <div class="line but" @click="login">
          登&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;录
        </div>

        <!-- <div class="line">
          <div class="cz" @click="download">飞机修理厂考试系统操作手册.pdf</div>
        </div> -->

        <div class="gx">
          <el-checkbox v-model="checked"
            >请勾选并同意<span>《用户协议》</span>和<span
              >《隐私政策》</span
            ></el-checkbox
          >
        </div>

        <!-- <div class="qh" @click="checkAdmin">
          <i class="iconfont icon-paimingbiaoqian"></i>切换至管理界面
        </div> -->
        <div class="tip"></div>
      </div>
    </div>
    <div class="copyright">{{ this.$copyright }}</div>
  </div>
</template>

<script>
import SIdentify from "../util/identify";
export default {
  components: {
    // Verify,
    //验证码
    SIdentify: SIdentify,
  },
  data() {
    return {
      loading: false,
      userName: "",
      password: "",
      yzm: "",
      identifyCode: "", //验证码
      contentWidth: 130,
      identifyCodes: "1234567890",
      checked: true,
    };
  },
  methods: {
    /**
     * 忘记密码
     */
    forgetPassword() {},
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
      }
      console.log(this.identifyCode);
    },
    //验证码abcdefghijklnmopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    /**
     * 下载用户操作手册
     */
    download() {
      window.opener(this.$baseurl + "/downloadModelFile?type=");
    },
    /**
     * 使用请求进行登录
     */
    async login() {
      let requestData = {
        account: this.userName,
        password: this.password,
      };
      console.log(requestData);
      let dd = this.isNotNull();
      if (!dd.flag) {
        this.$message({
          message: dd.msg,
          type: "warning",
          duration: 2000,
        });
        return;
      }
      try {
        this.loading = true;
        let data = await this.$request({
          url: "/user/loginAdmin",
          method: "post",
          data: requestData,
        });
        // let data = { userId: "1", userName: "张三" };
        sessionStorage.setItem("userData", JSON.stringify(data));
        sessionStorage.setItem("fatherMenu", "index");
        this.$message.success("登录成功!");
        this.$router.push("/index");
        this.loading = false;
      } catch (error) {
        this.$message.error(error.message);
        this.initInput();
        this.refreshCode();
        this.loading = false;
      }
    },
    /**
     * 登录前的非空判断
     */
    isNotNull() {
      let returnData = {
        flag: true,
        msg: "",
      };
      if (!this.checked) {
        returnData.flag = false;
        returnData.msg = "请先勾选并同意《用户协议》和《隐私政策》!";
        return returnData;
      }
      if (this.userName == "") {
        returnData.flag = false;
        returnData.msg = "用户名不可为空!";
        this.initInput();
        return returnData;
      }
      if (this.password == "") {
        returnData.flag = false;
        returnData.msg = "密码不可为空!";
        this.initInput();
        return returnData;
      }
      if (this.yzm == "") {
        returnData.flag = false;
        returnData.msg = "验证码不可为空!";
        this.initInput();
        return returnData;
      }
      if (this.yzm != this.identifyCode) {
        returnData.flag = false;
        returnData.msg = "验证码错误!";
        this.initInput();
        return returnData;
      }
      return returnData;
    },
    /**
     * 输入框置空
     */
    initInput() {
      // this.userName = "";
      this.password = "";
      this.yzm = "";
    },
    /**
    切换至管理界面
     */
    checkAdmin() {
      this.$router.push("/admin");
    },
  },
  mounted() {
    this.makeCode(this.identifyCodes, 4);
  },
};
</script>

<style lang="less" scoped>
#new_student_login {
  width: 100%;
  height: 100%;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background-image: url("../../assets/img/user_login2_2.png");
  background-size: 100% 100%;
  > .content {
    width: 500px;
    height: 680px;
    background-color: #ffffff;
    display: flex;
    margin-right: 280px;
    border-radius: 5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
    padding: 40px;
    padding-top: 0;
    box-sizing: border-box;
    > .login {
      width: 0;
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: column;
      padding: 0 20px;
      box-sizing: border-box;
      position: relative;
      // justify-content: center;
      > .top {
        width: 100%;
        height: 200px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #8b8b8b;
        > .tt {
          color: #2347a1;
          font-size: 35px;
          font-weight: 800;
        }
        > span {
          margin-top: 20px;
        }
        img {
          width: 100%;
        }
      }
      > .line {
        width: 100%;
        height: auto;
        margin-bottom: 30px;
        display: flex;
        /deep/ .el-input__inner {
          // border: none;
          // border-bottom: 1px solid @baseColor;
          // border-radius: 0;
          background-color: #faebd700;
          color: @baseColor;
          height: 50px;
        }
        > .yzm {
          width: 180px;
          height: 50px;
          margin-left: 10px;
          background-color: #fff;
        }
        > .wjmm {
          width: auto;
          color: #6199ff;
          font-size: 13px;
          padding: 0 5px;
          box-sizing: border-box;
          cursor: pointer;
          transition: 0.3s;
          &:hover {
            text-decoration: underline;
            text-underline-offset: 5px;
          }
        }
        > .cz {
          color: #aaaaaa;
          font-size: 12px;
          cursor: pointer;
          transition: 0.3s;

          &:hover {
            color: #4694fa;
            text-decoration: underline;
            text-underline-offset: 5px;
          }
        }
      }
      > .but {
        height: 60px;
        background-color: #2347a1;
        color: #fff;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        line-height: 40px;
        cursor: pointer;
        border-radius: 8px;
      }
      > .qh {
        width: auto;
        height: 40px;
        position: absolute;
        top: 8px;
        right: -10px;
        font-size: 15px;
        font-weight: 400;
        color: #2e46d1;
        transition: 0.3s;
        cursor: pointer;
        &:hover {
          // text-decoration: underline;
          // text-underline-offset: 5px;
        }
        > i {
          margin-right: 5px;
        }
      }
      > .tip {
        width: 195px;
        height: 195px;
        position: absolute;
        background-image: url("../../assets/img/user_login2_2_tip.png");
        top: -120px;
        right: -120px;
      }
      .gx {
        width: auto;
        height: 40px;
        position: absolute;
        bottom: 0px;
        left: 20px;
        font-size: 13px;
        font-weight: 400;
        color: #2e46d1;
        transition: 0.3s;
        cursor: pointer;
        &:hover {
          // text-decoration: underline;
          // text-underline-offset: 5px;
        }
        span {
          color: #1e36c0;
        }
      }
    }
  }
  > .copyright {
    width: 100%;
    height: 35px;
    position: absolute;
    bottom: 0;
    color: #fff;
    font-size: 13px;
  }
  > .title {
    width: auto;
    height: auto;
    font-size: 70px;
    font-weight: bold;
    color: #fff;
    position: absolute;
    top: 13%;
    left: 13%;
    letter-spacing: 12px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    > .t1 {
      font-size: 45px;
    }
    > .t2 {
      font-size: 60px;
      margin-top: 10px;
    }
  }
}
</style>